import React, { useEffect, useRef, useState } from 'react';
import { ShieldIcon, KeyIcon, LocationIcon, SupportIconWhyUs, AdblockIcon, ReferralIcon, CryptoIcon, PriceIcon } from './Icons';
import screenPhone from '../assets/screen_phone.png';

function WhyUs() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setIsVisible(true);
        observer.disconnect();
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12,
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: 'shield',
      text: 'Полная конфиденциальность Ваших данных и перемещений по сети'
    },
    {
      icon: 'location',
      text: 'Выбор локаций'
    },
    {
      icon: 'support',
      text: 'Поддержка всех устройств'
    },
    {
      icon: 'adblock',
      text: 'Блокировка рекламы YouTube'
    },
        {
      icon: 'price',
      text: 'Гибкий подбор тарифа'
    },
    {
      icon: 'crypto',
      text: 'Оплата криптовалютой'
    },
    {
      icon: 'key',
      text: 'Мультиаккаунт'
    },
    {
      icon: 'referral',
      text: 'Реферальная система'
    },
  ];

  const renderFeatureIcon = (icon) => {
    const sharedProps = { className: 'why-us__glyph' };

    if (icon === 'shield') return <ShieldIcon {...sharedProps} />;
    if (icon === 'key') return <KeyIcon {...sharedProps} />;
    if (icon === 'location') return <LocationIcon {...sharedProps} />;
    if (icon === 'support') return <SupportIconWhyUs {...sharedProps} />;
    if (icon === 'adblock') return <AdblockIcon {...sharedProps} />;
    if (icon === 'referral') return <ReferralIcon {...sharedProps} />;
    if (icon === 'crypto') return <CryptoIcon {...sharedProps} />;
    if (icon === 'price') return <PriceIcon {...sharedProps} />;

    return null;
  };

  return (
    <section
      ref={sectionRef}
      className={`why-us ${isVisible ? 'why-us--visible' : ''}`}
    >
      <div className="why-us__container">
        <div className="why-us__image">
          <svg width="500" height="750" viewBox="0 0 200 280" fill="none" style={{ maxWidth: '100%', height: 'auto' }}>
            <rect x="47" y="20" width="110" height="240" rx="19" fill="#1A1A1A" stroke="#D68027" strokeWidth="2" />
            <defs>
              <clipPath id="screenClip">
                <rect x="50" y="25" width="100" height="230" rx="14" />
              </clipPath>
            </defs>
            <image x="50" y="25" width="100" height="230" href={screenPhone} clipPath="url(#screenClip)" preserveAspectRatio="none" />
            <rect x="50" y="25" width="100" height="230" rx="14" fill="none" stroke="#D9B68B" strokeWidth="1" />
            <circle cx="100" cy="31" r="2.8" fill="#D68027" />
            <rect x="152" y="70" width="3" height="15" rx="1.5" fill="#D9B68B" />
            <rect x="152" y="90" width="3" height="15" rx="1.5" fill="#D9B68B" />
            <rect x="152" y="125" width="3" height="20" rx="1.5" fill="#D9B68B" />
            <rect x="80" y="251" width="40" height="1.5" rx="1" fill="#D9B68B" opacity="0.8" />
          </svg>
        </div>

        <div className="why-us__features">
          {features.map((feature, index) => (
            <div key={index} className="why-us__feature">
              <span className={`why-us__icon why-us__icon--${feature.icon}`}>
                {renderFeatureIcon(feature.icon)}
              </span>
              <span>{feature.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
